<script lang="ts">
  import { project, postUsers } from "$lib/services/store";
  import { page } from "$app/stores";
  import Icons from "$lib/main/components/Icons.svelte";
  import Translate from "$lib/admin/components/blocks/helpers/Translate.svelte";
  import type { PostUser, BlockProps } from "@/src/types/components/WriterMeta";

  export let props: BlockProps | null = null;

  $: userData = (() => {
    const currentWriterId = props?.writerId;
    if (Array.isArray($postUsers) && $postUsers.length > 0 && currentWriterId) {
      return $postUsers.find((x: PostUser) => x.id === currentWriterId) || null;
    }
    return null;
  })();
</script>

{#if userData}
  <div class="content-grid {props?.styling?.marginTop ?? ''} {props?.styling?.marginBottom ?? ''}" id="writer-meta">
    <div class="bg-red-50 rounded-lg p-6">
      {#if !props?.writerTitleHide}
        <h4 class="uppercase font-[400]">
          {#if props?.writerTitle}
            {props.writerTitle}
          {:else}
            <Translate text="Content editor" />
          {/if}
        </h4>
      {/if}
      <div class="flex gap-4 flex-col md:flex-row">
        <div class="flex w-full md:w-1/3 justify-around">
          <div class="flex gap-6">
            <div class="rounded-full overflow-hidden" class:fallback={!userData?.avatar_url}>
              <img
                loading="lazy"
                class="w-24 h-24"
                alt={userData?.full_name ?? $project.name + " Team"}
                src={userData?.avatar_url
                  ? $project.data?.imageFolders?.profiles +
                    userData?.avatar_url.split("/").pop() +
                    "?w=200&h=200&q=80&auto=format&fit=crop"
                  : $project.data?.imageFolders?.assets + $project.name_lower + "-logo.png?q=80&auto=format"} />
            </div>
            <div class="flex flex-col">
              {#if userData?.data?.[$project.key]?.page && $page.url.pathname != userData?.data?.[$project.key]?.page}
                <a href={userData?.data?.[$project.key]?.page} class="font-light text-sm">
                  {userData?.display_name ?? $project.name + " Team"}
                </a>
                <a
                  href={userData?.data?.[$project.key]?.page}
                  class="font-normal text-gray-500 text-xs hover:text-gray-400">
                  {userData?.data?.[$project.key]?.role ?? "Group effort"}
                </a>
              {:else}
                <p class="writer-name">{userData?.display_name ?? $project.name + " Team"}</p>
                <p class="writer-role">{userData?.data?.[$project.key]?.role ?? "Group effort"}</p>
              {/if}
              <div class="flex gap-2 mt-4">
                <a
                  class={"flex items-center p-2 bg-white rounded-sm hover:rounded-full transition ease-in-out delay-150" +
                    (!userData?.data?.[$project.key]?.contact_email ? " disabled" : "")}
                  href={"mailto:" + userData?.data?.[$project.key]?.contact_email}
                  target="_blank"
                  rel="nofollow noreferrer"
                  title={"Maila " + userData?.full_name}>
                  <Icons name="mail" color="#c71610" strokeWidth="2.5" />
                </a>
                <a
                  class={"flex items-center p-2 bg-blue-500 rounded-sm hover:rounded-full transition-all" +
                    (!userData?.data?.[$project.key]?.linkedin ? " disabled" : "")}
                  href={userData?.data?.[$project.key]?.linkedin}
                  target="_blank"
                  rel="author noreferrer"
                  title={userData?.full_name + " på LinkedIn"}>
                  <Icons name="linkedin" color="#fff" strokeWidth="1.5" />
                </a>
              </div>
            </div>
          </div>
          <div class="none md:block w-[1px] h-full bg-gray-300"></div>
        </div>
        <div class="flex w-full md:w-2/3 items-center">
          <p class="text-md">
            {userData?.data?.[$project.key]?.bio ??
              "Content produced as a collaboration between our resident experts here at " + $project.name}
          </p>
        </div>
      </div>
    </div>
  </div>
{/if}
